import { QueryFunctionContext } from "@tanstack/react-query";

import type {
  CreateUserPayload,
  ExportUserRole,
  UpdateUserPayload,
  User,
} from "@web-app/types";
import http from "@web-app/utils/http";

const base_url = "/users";

export const list = async (workspaceId: string) => {
  return http
    .get<User[]>(base_url, {
      params: {
        workspaceId,
      },
    })
    .then((response) => response.data);
};

export const create = async (payload: CreateUserPayload) => {
  return http
    .post<User>(`${base_url}`, payload)
    .then((response) => response.data);
};

export const update = async (
  id: string,
  payload: Partial<UpdateUserPayload>,
) => {
  return http
    .patch<User>(`${base_url}/${id}`, payload)
    .then((response) => response.data);
};

export const updateCurrentWorkspace = async (workspaceId: string) => {
  return http
    .patch<User>(`${base_url}/switchWorkspace/${workspaceId}`, { workspaceId })
    .then((response) => response.data);
};

export const deactivate = async (payload: { userId: string }) => {
  return http
    .post(`/auth/deactivateUser`, payload)
    .then((response) => response.data);
};

export const remove = async (payload: {
  userId: string;
  workspaceId: string;
}) => {
  return http
    .delete(`workspaces/${payload.workspaceId}/users/${payload.userId}`)
    .then((response) => response.data);
};

export const getOne = async ({ signal, queryKey }: QueryFunctionContext) => {
  const [, userId] = queryKey;
  return http
    .get<User>(`users/${userId}`, { signal })
    .then((response) => response.data);
};

export const getExcel = async (roles: ExportUserRole[]) => {
  return http
    .post<Blob>(
      `/export/users`,
      {
        roles,
      },
      {
        responseType: "blob",
      },
    )
    .then((response) => response.data);
};
